module.exports = __webpack_public_path__ + "static/bee-change-a7708826a77f2d979e8ee4b4c0541dd3.png";